import React from 'react';
import { EyengagePost } from "src/shared/types/src";
import LocalImages from '../../../static'
import { format, parse } from 'date-fns';

const EventDetails = ({ postData }: { postData: EyengagePost }) => {

    const eventMeta = postData?.eventMeta

    const openMaps = () => {
        if (!eventMeta?.location?.latitude || !eventMeta?.location?.longitude) return;

        const lat = parseFloat(eventMeta?.location?.latitude);
        const lng = parseFloat(eventMeta?.location?.longitude);

        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

        window.open(googleMapsUrl, '_blank');
    };

    return (
        <div className='event-details'>
            {eventMeta?.name ? 
                <div className='event-details-item'>
                    <img src={LocalImages.starIcon} alt="star-icon"/>
                    <div className='event-details-label fw-bold'>{eventMeta.name}</div>
                </div> : null
            }
            <div className='event-details-item'>
                <img src={LocalImages.calendarIcon} alt="calendar-icon"/>
                <div className='event-details-label'>
                    {eventMeta?.date ? `${format(new Date(eventMeta.date), 'EEE dd MMM yyyy')},` : ''} {eventMeta?.startTime ? format(parse(eventMeta.startTime, 'HH:mm', new Date()), 'h:mm a').toUpperCase() : ''}{eventMeta?.endTime ? ` - ${format(parse(eventMeta.endTime, 'HH:mm', new Date()), 'h:mm a').toUpperCase()}` : ''}
                </div>
            </div>
            {eventMeta?.location?.address ?
                <div className='event-details-item'>
                    <img src={LocalImages.locationIcon} alt="location-icon"/>
                    <div className='event-details-label cursor-pointer' onClick={openMaps}>
                        {eventMeta.location.address}
                    </div>
                </div> : null
            }
        </div>
    );
};

export default EventDetails;
